<template>
    <div>
        <page-header>
            <template #breadcrumbs>
                <router-link to="/admin/poll">Анкеты</router-link> &raquo;
                <span>{{ item.name }}</span>
            </template>
            <h2>Анкета</h2>
        </page-header>
        <ul class="nav nav-tabs nav-justified mt-3">
            <li class="nav-item">
                <a
                        class="nav-link"
                        @click.prevent="setActive('tabGeneral')"
                        :class="{ active: isActive('tabGeneral') }"
                        href="#tabGeneral"
                >Общая информация</a>
            </li>
            <li class="nav-item">
                <a
                        class="nav-link"
                        @click.prevent="setActive('tabQuestions')"
                        :class="{ active: isActive('tabQuestions') }"
                        href="#tabQuestions"
                >Вопросы</a>
            </li>
        </ul>
        <div class="card" v-if="item">
            <div class="tab-content p-3" id="myTabContent" v-disable-all="isReadonly">
                <div
                        class="tab-pane fade"
                        :class="{ 'active show': isActive('tabGeneral') }"
                        id="tabGeneral"
                >
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group required">
                                <component-input
                                        v-model="item.name"
                                        label="Название" required
                                        placeholder="Введите название"/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group required">
                                <label class="control-label">Текст</label>
                                <textarea v-model="item.text" class="form-control" rows="10"/>
                                <div class="invalid-msg" v-if="v$.item.text.$error">Поле обязательно для заполнения</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group required">
                                <component-input
                                        v-model="item.resultTitle"
                                        label="Заголовок результата" required
                                        placeholder="Введите Заголовок результата"/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group required">
                                <label class="control-label">Рекомендации для высокого риска</label>
                                <textarea v-model="item.highRiskText" class="form-control" rows="3"/>
                                <div class="invalid-msg" v-if="v$.item.highRiskText.$error">Поле обязательно для заполнения</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group required">
                                <label class="control-label">Рекомендации для низкого риска</label>
                                <textarea v-model="item.lowRiskText" class="form-control" rows="3"/>
                                <div class="invalid-msg" v-if="v$.item.lowRiskText.$error">Поле обязательно для заполнения</div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group required">
                                <label class="control-label">Рекомендации для среднего риска</label>
                                <textarea v-model="item.mediumRiskText" class="form-control" rows="3"/>
                                <div class="invalid-msg" v-if="v$.item.mediumRiskText.$error">Поле обязательно для заполнения</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                        class="tab-pane fade"
                        :class="{ 'active show': isActive('tabQuestions') }"
                        id="tabQuestions"
                >
                    <table class="table table-bordered table-striped">
                        <thead>
                        <tr>
                            <th class="w-5">№</th>
                            <th>Вопрос</th>
                            <th>Вес ответа "Да"</th>
                            <th>Вес ответа "Нет"</th>
                            <th>Активен</th>
                            <th>Комментарий</th>
                            <th v-if="!isReadonly"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="quest in item.questions" :key="quest.id">
                            <td class="w-5">{{quest.orderNum}}</td>
                            <td>{{quest.name}}</td>
                            <td>{{quest.yesWeight}}</td>
                            <td>{{quest.noWeight}}</td>
                            <td>{{quest.isActive ? 'Да' : 'Нет'}}</td>
                            <td>{{quest.comment}}</td>
                            <td v-if="!isReadonly">
                                <button class="btn"><i class="fas fa-pen" v-if="!isReadonly" v-on:click="editQuestion(quest)"/></button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="float-right d-flex align-items-center">
                <button-component type="button" class="btn btn-primary mr-2 btn-sm" v-if="!isReadonly"
                                  v-on:click="save">Сохранить</button-component>
                <button-component type="button" kind="secondary" class="btn btn-secondary btn-sm"
                                  v-on:click="close">Закрыть</button-component>
            </div>
        </div>
        <section class="modals">
            <modal-component v-if="modals.editQuestion" title="Редактирование вопроса" size-class=""
                             @close="modals.editQuestion = false">
                <edit-poll-question :value="currentQuestion" v-on:save="saveQuestion" @close="modals.editQuestion = false"/>
            </modal-component>
        </section>
    </div>
</template>

<script>
  import Api from "../api/poll";
  import PageHeader from "../../../common/components/page/PageHeader";
  import ButtonComponent from "../../../common/ui/ButtonComponent";
  import disableAll from "../../../common/directives/disable-all";
  import security from "../../../common/mixins/security";
  import {useVuelidate} from "@vuelidate/core";
  import {maxLength, required} from "@vuelidate/validators";
  import Constants from "../../../common/constants";
  import ComponentInput from "../../../common/components/ComponentInput";
  import ModalComponent from "../../../common/ui/ModalComponent";
  import EditPollQuestion from "../components/EditPollQuestion";
  export default {
    name: "PollCard",
    components: {EditPollQuestion, ModalComponent, ComponentInput, ButtonComponent, PageHeader},
    directives: {
      'disable-all': disableAll
    },
    mixins: [security],
    data() {
      return {
        id: this.$route.params.id,
        isReadonly: this.$route.params.action === 'view',
        activeItem: "tabGeneral",
        item: {},
        currentQuestion: {},
        modals: {
          editQuestion: false
        }
      }
    },
    created() {
      this.checkPermissions([Constants.PollEdit, Constants.PollView]);
      this.loadCard();
    },
    methods: {
      isActive(menuItem) {
        return this.activeItem === menuItem;
      },
      setActive(menuItem) {
        this.activeItem = menuItem;
      },
      loadCard() {
        Api.find(this.id).then((response) => {
          this.item = response.data;
          this.item.questions = this.item.questions.sort((a, b) => {
            return a.orderNum - b.orderNum;
          });
        });
      },
      editQuestion(quest) {
        this.currentQuestion = quest;
        this.modals.editQuestion = true;
      },
      saveQuestion(value) {
        this.modals.editQuestion = false;
        let quest = this.item.questions.find(x => x.id === value.id);
        quest.name = value.name;
        quest.comment = value.comment;
        Api.updateQuestion(quest).then((response) => {
          Constants.alert.fire('Сохранение вопроса', response.data.message, response.data.success ? 'success' : 'error');
        }).catch(() => {
          Constants.alert.fire('Сохранение вопроса', Constants.commonError, 'error');
        });
      },
      save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }

        Api.update(this.item).then((response) => {
          Constants.alert.fire('Сохранение', response.data.message, response.data.success ? 'success' : 'error');
        }).catch(() => {
          Constants.alert.fire('Сохранение', Constants.commonError, 'error');
        });
      },
      close() {
        this.$router.push({name: 'Polls'});
      }
    },
    setup: () => ({ v$: useVuelidate() }),
    validations () {
      return {
        item: {
          name: {
            required,
            maxLength: maxLength(255)
          },
          text: {
            required
          },
          resultTitle: {
            required,
            maxLength: maxLength(255)
          },
          highRiskText: {
            required
          },
          lowRiskText: {
            required
          },
          mediumRiskText: {
            required
          }
        }
      };
    }
  }
</script>

<style lang="scss" scoped>
    @import '/src/assets/theme/default/colors.scss';

    .nav-tabs {
      margin: 16px 36px 0 36px;
      justify-content: center;
      border: none;
      .nav-item {
        margin-top: 12px;
        max-width: 240px;
        min-width: 217px;
        width: 100%;
        margin-right: 8px;
        margin-left: 8px;
        .nav-link {
          padding: 14.5px 34.5px;
          text-align: center;
          font-family: "Source Sans Pro", sans-serif;
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 120%;
          color: $gray-dark;
          border: 1px solid $gray-light1;
          box-sizing: border-box;
          border-radius: 6px;

          &.active {
            color: $blue-light;
            border: 1px solid $blue-light;
          }
        }
      }
    }
    .form-group.required .control-label:after {
        content:" *";
        color:red;
    }
    .invalid-msg {
        color:red;
    }
    .card {
        padding: 24px;
        margin: 16px 24px 0 24px;
        border-radius: 12px;
        border: none;
        box-shadow: none;
        background-color: #fff;
    }

    .table-bordered td:first-child {
        width: 35%;
    }
    .w-5 {
        width: 5% !important;
    }
</style>